import AuthService from "../services/auth.service";
import { getItem, clear } from "../store/localStorage";

const loggeduser = JSON.parse(getItem('loggeduser'));
const rights = JSON.parse(getItem('rights'));
const userParam = getItem('userParam');
const userMenu = getItem('userMenu');

const initialState = {
  status: { loggedIn: !!loggeduser },
  loggeduser,
  rights,
  userParam,
  userMenu,
};

export function existAuthorityCode(auth_code) {
  const rights = JSON.parse(getItem("rights"));
  return !!(auth_code || rights);
}

export function existAuthorityCodeWithDTYPE(auth_code, device_code) {
  const rights = JSON.parse(getItem("rights"));
  if (!rights || !auth_code) return false;

  let auth_code_genel = auth_code.startsWith("BRANDS/") ?
    "BRANDS/GENEL" + auth_code.substring(auth_code.lastIndexOf("/")) : null;

  for (let row of rights) {
    if (auth_code === row.right_code ||
       (auth_code_genel && auth_code_genel === row.right_code)) {
      const user = JSON.parse(getItem("loggeduser"));
      if (!user || !user.authorized_device_types) return false;

      if (auth_code.startsWith("BRANDS/")) {
        return checkBrandsAuth(auth_code, device_code, user);
      } else {
        return checkUserAuth(device_code, user);
      }
    }
  }
  return false;
}

function checkBrandsAuth(auth_code, device_code, user) {
  return (
    user.authorized_device_types.includes(device_code + "_2") ||
    (user.authorized_device_types.includes(device_code + "_1") &&
      !auth_code.endsWith("/LEVEL4")) ||
    (auth_code.endsWith("/SPECIAL") &&
      user.authorized_device_types.includes(device_code + "_0"))
  );
}

function checkUserAuth(device_code, user) {
  return (
    user.authorized_device_types.includes(device_code + "_1") ||
    user.authorized_device_types.includes(device_code + "_0")
  );
}

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    async googleAccount({ commit }, user) {
      try {
        const userData = await AuthService.googleAccount(user);
        commit("googleSuccess", userData);
        return userData;
      } catch (error) {
        commit("googleFailure");
        throw error;
      }
    },
    async googleLogin({ commit }, user) {
      try {
        const userData = await AuthService.googleLogin(user);
        commit("googleLoginSuccess", userData);
        return userData;
      } catch (error) {
        commit("googleLoginFailure");
        throw error;
      }
    },
    async googleSignIn({ commit }, userInfo) {
      try {
        const userData = await AuthService.googleSignIn(userInfo);
        commit("signInSuccess", userData);
        return userData;
      } catch (error) {
        commit("signInFailure");
        throw error;
      }
    },
    async login({ commit }, user) {
      try {
        const userData = await AuthService.login(user);
        commit("loginSuccess", userData);
        return userData;
      } catch (error) {
        commit("loginFailure");
        throw error;
      }
    },
    logout({ commit }) {
      AuthService.logout();
      commit("logout");
    },
    async register({ commit }, user) {
      try {
        const response = await AuthService.register(user);
        commit("registerSuccess");
        return response.data;
      } catch (error) {
        commit("registerFailure");
        throw error;
      }
    },
  },
  mutations: {
    googleSuccess(state) {
      state.status.loggedIn = true;
    },
    googleFailure(state) {
      state.status.loggedIn = false;
    },
    googleLoginSuccess(state) {
      state.status.loggedIn = true;
    },
    googleLoginFailure(state) {
      state.status.loggedIn = false;
    },
    loginSuccess(state) {
      state.status.loggedIn = true;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
    },
    logout(state) {
      Object.assign(state, {
        status: { loggedIn: false },
        loggeduser: null,
        rights: null,
        userParam: null,
        userMenu: null,
      });
      clear();
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
  },
};
